import { render, staticRenderFns } from "./PADetails.vue?vue&type=template&id=55c3f7a6&scoped=true"
import script from "./PADetails.vue?vue&type=script&lang=js"
export * from "./PADetails.vue?vue&type=script&lang=js"
import style0 from "./PADetails.vue?vue&type=style&index=0&id=55c3f7a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c3f7a6",
  null
  
)

export default component.exports